import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/mockData';

const CategoryGrid = () => {
  return (
    <section className="bg-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {categories.map((category, index) => {
            // Special case: Blog category should link to the blog page
            const linkPath = category.slug === 'blog' 
              ? '/blog' 
              : `/category/${category.slug}`;
            
            return (
              <Link
                key={category.id}
                to={linkPath}
                className="bg-white border border-gray-200 rounded-lg py-4 px-6 text-center hover:shadow-md hover:border-[#000000] transition-all duration-300 group card-hover animate-fadeInUp opacity-0"
                style={{ animationDelay: `${index * 0.03}s`, animationFillMode: 'forwards' }}
              >
                <span className="text-gray-700 font-medium group-hover:text-gray-800 transition-colors">
                  {category.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
